var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommunityPatientLeaflets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43991 21.6192H8.55021V25.3792H1.43991V21.6192Z",
    fill: "#0D0C22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1049 21.6191H24.0772V25.3791H14.1049V21.6191Z",
    fill: "#0D0C22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1981 2.21955H25.9577V18.6473H22.1981V2.21955Z",
    fill: "#0D0C22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1981 45.7161H25.9577V52.7111H22.1981V45.7161Z",
    fill: "#0D0C22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9571 41.2583H22.1975V33.2401H1.43991V29.4801H24.0774C25.1156 29.4801 25.9571 30.3218 25.9571 31.3601V41.2583Z",
    fill: "#0D0C22"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.518 21.6193H54.4918V25.3793H47.518V21.6193Z",
    fill: "#0D0C22"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1678 25.3796H31.8537C30.8156 25.3796 29.974 24.5379 29.974 23.4996V9.41879H33.7336V21.6195H43.168L43.1678 25.3796Z",
    fill: "#0D0C22"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.974 2.21955H33.7336V6.29566H29.974V2.21955Z",
    fill: "#0D0C22"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7336 52.7112H29.974V31.3601C29.974 30.3218 30.8156 29.4801 31.8537 29.4801H37.5109V33.2401H33.7336V52.7112Z",
    fill: "#0D0C22"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0122 29.4801H54.4907V33.2401H42.0122V29.4801Z",
    fill: "#0D0C22"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71858 2.21997H16.3526V16.2743H2.71858V2.21997Z",
    fill: "#25963E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3529 18.1534H2.71884C1.68068 18.1534 0.839111 17.3117 0.839111 16.2734V2.21903C0.839111 1.18074 1.68068 0.339032 2.71884 0.339032H16.3529C17.391 0.339032 18.2326 1.18074 18.2326 2.21903V16.2734C18.2326 17.3118 17.391 18.1534 16.3529 18.1534ZM4.59871 14.3934H14.4731V4.09903H4.59871V14.3934Z",
    fill: "#0D0C22"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75051 6.24847H8.76453C10.9892 6.24847 12.7926 4.44488 12.7926 2.2199H2.72234V12.9628C4.94705 12.9628 6.75051 11.1592 6.75051 8.93419V6.24847Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65671 7.20861H11.4163V11.2847H7.65671V7.20861Z",
    fill: "#0D0C22"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3529 18.1534H2.71884C1.68068 18.1534 0.839111 17.3117 0.839111 16.2734V2.21903C0.839111 1.18074 1.68068 0.339032 2.71884 0.339032H16.3529C17.391 0.339032 18.2326 1.18074 18.2326 2.21903V16.2734C18.2326 17.3118 17.391 18.1534 16.3529 18.1534ZM4.59871 14.3934H14.4731V4.09903H4.59871V14.3934Z",
    fill: "#0D0C22"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5782 2.21997H53.2123V16.2743H39.5782V2.21997Z",
    fill: "#25963E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2126 18.1534H39.5785C38.5402 18.1534 37.6988 17.3117 37.6988 16.2734V2.21903C37.6988 1.18074 38.5403 0.339032 39.5785 0.339032H53.2126C54.2507 0.339032 55.0923 1.18074 55.0923 2.21903V16.2734C55.0923 17.3118 54.2507 18.1534 53.2126 18.1534ZM41.4582 14.3934H51.3327V4.09904H41.4582V14.3934Z",
    fill: "#0D0C22"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6085 6.24861H45.6225C47.8473 6.24861 49.6506 4.44501 49.6506 2.22003H39.5803V12.9629C41.8051 12.9629 43.6084 11.1593 43.6084 8.93432L43.6085 6.24861Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5145 7.20884H48.274V11.285H44.5145V7.20884Z",
    fill: "#0D0C22"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2126 18.1534H39.5785C38.5402 18.1534 37.6988 17.3117 37.6988 16.2734V2.21903C37.6988 1.18074 38.5403 0.339032 39.5785 0.339032H53.2126C54.2507 0.339032 55.0923 1.18074 55.0923 2.21903V16.2734C55.0923 17.3118 54.2507 18.1534 53.2126 18.1534ZM41.4582 14.3934H51.3327V4.09904H41.4582V14.3934Z",
    fill: "#0D0C22"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5297 38.6566H53.1637V52.7109H39.5297V38.6566Z",
    fill: "#25963E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1642 54.5905H39.5301C38.492 54.5905 37.6504 53.7488 37.6504 52.7105V38.6561C37.6504 37.6178 38.492 36.7761 39.5301 36.7761H53.1642C54.2023 36.7761 55.0439 37.6178 55.0439 38.6561V52.7105C55.0439 53.7488 54.2025 54.5905 53.1642 54.5905ZM41.41 50.8305H51.2844V40.5361H41.41V50.8305Z",
    fill: "#0D0C22"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5617 42.6856H45.5758C47.8005 42.6856 49.6038 40.882 49.6038 38.6571H39.5336V49.3999C41.7583 49.3999 43.5616 47.5963 43.5616 45.3714L43.5617 42.6856Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4663 43.646H48.2259V47.7221H44.4663V43.646Z",
    fill: "#0D0C22"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1642 54.5905H39.5301C38.492 54.5905 37.6504 53.7488 37.6504 52.7105V38.6561C37.6504 37.6178 38.492 36.7761 39.5301 36.7761H53.1642C54.2023 36.7761 55.0439 37.6178 55.0439 38.6561V52.7105C55.0439 53.7488 54.2025 54.5905 53.1642 54.5905ZM41.41 50.8305H51.2844V40.5361H41.41V50.8305Z",
    fill: "#0D0C22"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71858 38.6564H16.3526V52.7107H2.71858V38.6564Z",
    fill: "#25963E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3529 54.5903H2.71884C1.68068 54.5903 0.839111 53.7486 0.839111 52.7103V38.6559C0.839111 37.6177 1.68068 36.7759 2.71884 36.7759H16.3529C17.391 36.7759 18.2326 37.6177 18.2326 38.6559V52.7103C18.2326 53.7486 17.391 54.5903 16.3529 54.5903ZM4.59871 50.8303H14.4731V40.5359H4.59871V50.8303Z",
    fill: "#0D0C22"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75051 42.6849H8.76453C10.9892 42.6849 12.7926 40.8813 12.7926 38.6563H2.72234V49.3992C4.94705 49.3992 6.75038 47.5956 6.75038 45.3706L6.75051 42.6849Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65671 43.6455H11.4163V47.7216H7.65671V43.6455Z",
    fill: "#0D0C22"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3529 54.5903H2.71884C1.68068 54.5903 0.839111 53.7486 0.839111 52.7103V38.6559C0.839111 37.6177 1.68068 36.7759 2.71884 36.7759H16.3529C17.391 36.7759 18.2326 37.6177 18.2326 38.6559V52.7103C18.2326 53.7486 17.391 54.5903 16.3529 54.5903ZM4.59871 50.8303H14.4731V40.5359H4.59871V50.8303Z",
    fill: "#0D0C22"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityPatientLeaflets);
export default __webpack_public_path__ + "static/media/communityPatientLeaflets.aa9b66ca.svg";
export { ForwardRef as ReactComponent };